module.exports = __webpack_public_path__ + "static/media/accordion-plus.svg";